export const MAX_DASHBOARD_DAYS = 90;
const DAY_MS = 86400000;

export function dateInputValue(value?: Date | null): string {
  if (!value) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

export function getOneMonthBefore(date: Date): Date {
  const result = new Date(date);
  const currentDay = result.getDate();
  const targetMonth = result.getMonth() - 1;
  result.setMonth(targetMonth);
  if (result.getMonth() !== (targetMonth + 12) % 12) {
    result.setDate(0);
  }
  result.setHours(0, 0, 0, 0);
  return result;
}

export function normalizeDashboardRange(start?: Date, end?: Date, now = new Date()) {
  const final = new Date(end && !Number.isNaN(end.getTime()) ? end : now);
  final.setHours(23, 59, 59, 999);
  const todayEnd = new Date(now);
  todayEnd.setHours(23, 59, 59, 999);
  if (final > todayEnd) final.setTime(todayEnd.getTime());

  const earliest = new Date(final);
  earliest.setDate(earliest.getDate() - (MAX_DASHBOARD_DAYS - 1));
  earliest.setHours(0, 0, 0, 0);

  const initial = start && !Number.isNaN(start.getTime())
    ? new Date(start)
    : getOneMonthBefore(final);
  initial.setHours(0, 0, 0, 0);

  if (initial < earliest) initial.setTime(earliest.getTime());
  if (initial > final) { initial.setTime(final.getTime()); initial.setHours(0, 0, 0, 0); }
  return { start: initial, end: final };
}

export function dashboardRangeError(start: string, end: string): string {
  if (!start || !end) return 'Selecione as duas datas.';
  if (start > end) return 'A data inicial deve ser anterior ou igual à final.';
  if (end > dateInputValue(new Date())) return 'A data final não pode estar no futuro.';
  // Calendar-day comparison is independent of daylight-saving transitions.
  if ((Date.parse(end) - Date.parse(start)) / DAY_MS + 1 > MAX_DASHBOARD_DAYS) return 'Período · máximo 90 dias';
  return '';
}

export function isHistoricalRange(end?: Date | null, now = new Date()): boolean {
  if (!end) return false;
  return dateInputValue(new Date(end)) !== dateInputValue(now);
}

export function dashboardReferenceTime(end: Date): Date {
  return new Date(Math.min(new Date(end).getTime(), Date.now()));
}
